import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import { Recurrence } from "../../../types";
import CardText from "../../CardText";

type Props = {
  cancellationInfo: Recurrence["cancellationInfo"];
};

export default function CancellationInfo({ cancellationInfo }: Props) {
  if (!cancellationInfo) {
    return null;
  }

  const { text, reason } = cancellationInfo;

  return (
    <View>
      <ErrorText text={text} />
      {reason && <ErrorText text={reason} />}
    </View>
  );
}

function ErrorText({ text }: { text: string }) {
  const tailwind = useTailwind();
  return <CardText.Body text={text} error style={tailwind("mt-2")} />;
}
